<template>
  <b-card bg-variant="light">
    <b-row>
      <b-col class="mb-2">
        <strong>Geben Sie Adresse und Ort des Gebäudes ins Suchfeld ein und wählen Sie aus der Liste:</strong>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col">
        <autocomplete
          :search="getLocation"
          :get-result-value="getResultValue"
          @submit="handleSelectLocation"
          placeholder="Suche"
          class="type-ahead"
        >
          <template
            #default="{
              rootProps,
              inputProps,
              inputListeners,
              resultListProps,
              resultListListeners,
              results,
              resultProps
            }"
          >
            <div v-bind="rootProps">
              <input
                v-bind="inputProps"
                v-on="inputListeners"
                :class="[
                  'autocomplete-input',
                  { 'autocomplete-input-no-results': noSearchResults },
                ]"
                ref="inputField"
              />
              <ul
                v-if="noSearchResults"
                class="autocomplete-result-list"
                style="position: absolute; z-index: 1; width: 100%; top: 100%;"
                ref="noResult"
              >
                <li class="autocomplete-result">
                  Adresse wurde nicht gefunden.<br>
                  <a @click="showForm(true, true)" class="link">Zur manuellen Eingabe</a>
                </li>
              </ul>
              <ul v-bind="resultListProps" v-on="resultListListeners" ref="searchResult">
                <li
                  v-for="(result, index) in results"
                  :key="resultProps[index].id"
                  v-bind="resultProps[index]"
                >
                  {{ getResultValue(result) }}
                </li>
                <li class="autocomplete-result" v-if="inputLength > 4">
                  Keine der vorgeschlagenen Adressen.<br>
                  <a @click="showForm(true, true)" class="link">Zur manuellen Eingabe</a>
                </li>
              </ul>
            </div>
          </template>
        </autocomplete>
        <div id="map" class="map" ref="map"></div>
        <b-button
          v-if="showMap && isValidCommunity && hasFoundResult"
          @click="handleEgidClick()"
          variant="danger"
          class="mt-2"
        >
          Adresse übernehmen
        </b-button>
        <b-alert
          v-else-if="!isValidCommunity && hasFoundResult"
          variant="danger"
          show
          class="mt-2 mb-0"
        >
          Für das Gebäude wurde keine St.Galler Gemeinde erkannt
        </b-alert>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import { mapState } from 'vuex'
  import $ from 'jquery'
  import axios from 'axios'
  import Autocomplete from '@trevoreyre/autocomplete-vue'
  import '@trevoreyre/autocomplete-vue/dist/style.css'

  let map

  export default {
    data: () => ({
      attributes: {},
      inputLength: 0,
      tempGemeindeId: null,
      showMap: true
    }),
    props: {
      form: Object
    },
    created () {
      this.$store.commit('property/SET_IS_FORM_VISIBLE', false)
    },
    methods: {
      showForm (isFormVisible, shouldHideMap) {
        document.activeElement.blur()

        if (this.$refs.noResult) {
          this.$refs.noResult.style.visibility = 'hidden'
        }
        if (this.$refs.searchResult) {
          this.$refs.searchResult.style.visibility = 'hidden'
        }
        if (shouldHideMap) {
          this.showMap = false
          $(this.$refs.map).empty()
        }
        this.$store.commit('property/SET_IS_FORM_VISIBLE', isFormVisible)
      },
      getLocation (input) {
        this.inputLength = input.length

        return new Promise(resolve => {
          if (input.length < 5) {
            $(this.$refs.map).empty()
            this.showMap = false
            return resolve([])
          }

          axios.get(`https://api3.geo.admin.ch/rest/services/api/SearchServer?searchText=${encodeURI(input)}&type=locations`, {
            type: 'locations',
            withCredentials: false
          })
            .then((res) => {
              if (res.data.results && res.data.results.length) {
                return resolve(res.data.results.filter(e => e.attrs.origin === 'address'))
              }
              this.attributes = {}
              $(this.$refs.map).empty()
              return resolve([])
            })
            .catch(() => {
              this.attributes = {}
              $(this.$refs.map).empty()
              return resolve([])
            })
        })
      },
      getMap (selectedObject) {
        if (selectedObject) {
          $(this.$refs.map).empty()

          const egidNr = selectedObject.attrs.featureId.split('_')[0]
          return axios.get(`https://api3.geo.admin.ch/rest/services/api/MapServer/find?layer=ch.bfs.gebaeude_wohnungs_register&searchField=egid&returnGeometry=false&contains=false&searchText=${egidNr}`, {
            withCredentials: false
          })
            .then((data) => {
              const objekt = data.data.results[0]
              this.attributes = objekt.attributes

              if (!objekt.attributes.deinr) {
                this.attributes.deinr = ''
              }

              map = new ga.Map({  /* eslint-disable-line */
                target: 'map',
                view: new ol.View({  /* eslint-disable-line */
                  resolution: 650,
                  center: [2660000, 1190000]
                })
              })
              // Create a background layer
              var lyr1 = ga.layer.create('ch.swisstopo.pixelkarte-farbe'); /* eslint-disable-line */

              // Add the background layer in the map
              map.addLayer(lyr1)

              var parseExtent = function (stringBox2D) {
                var extent = stringBox2D.replace('BOX(', '').replace(')', '').replace(',', ' ').split(' ')
                var extentParsed = extent.map(e => parseFloat(e))
                return extentParsed
              }

              // Initialize the location marker
              var element = $("<div class='marker'></div>")
              var popup = new ol.Overlay({  /* eslint-disable-line */
                positioning: 'bottom-center',
                element: element
              })
              map.addOverlay(popup)

              var infoText = $("<div class='info-text' ref='map'>" + objekt.attributes.strname_deinr + '<br />' + objekt.attributes.dplz4 + ' ' + objekt.attributes.dplzname + '<br />EGID: ' + objekt.attributes.egid + "<!--<br /><br /><a class='btn btn-danger' onclick=''>Übernehmen</a></div>-->")
              var infos = new ol.Overlay({ /* eslint-disable-line */
                positioning: 'bottom-center',
                element: infoText
              })
              map.addOverlay(infos)

              var originZoom = {
                address: 10,
                parcel: 10,
                sn25: 8,
                feature: 7
              }

              var view = map.getView()
              var origin = selectedObject.attrs.origin
              var extent = [0, 0, 0, 0]

              if (selectedObject.attrs.geom_st_box2d) {
                extent = parseExtent(selectedObject.attrs.geom_st_box2d)
              } else if (selectedObject.attrs.x && selectedObject.attrs.y) { /* eslint-disable-line */
                var x = selectedObject.attrs.y
                var y = selectedObject.attrs.x
                extent = [x, y, x, y]
              }

              if (originZoom.hasOwnProperty(origin)) { /* eslint-disable-line */
                var zoom = originZoom[origin]
                var center = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2]
                view.setZoom(zoom)
                view.setCenter(center)
                popup.setPosition(center)
                infos.setPosition(center)
              } else {
                popup.setPosition([0, 0])
                infos.setPosition([0, 0])
                view.fitExtent(extent, map.getSize())
              }
            })
            .catch((err) => {
              console.error(err)
            })
        }
      },
      handleEgidClick () {
        this.showForm(true, false)
        this.form.strasse = this.attributes.strname[0]
        this.form.hausNr = `${this.attributes.deinr}`
        this.form.plz = `${this.attributes.dplz4}`
        this.form.ort = this.attributes.dplzname
        this.form.egid = `${this.attributes.egid}`
        this.form.gemeindeId = this.tempGemeindeId
      },
      getResultValue (result) {
        return result.attrs.label.replace(/<[/]?(b)>/gi, '')
      },
      async handleSelectLocation (result) {
        this.showMap = true
        await this.getMap(result)
        this.checkIsValidCommunity(result)
      },
      checkIsValidCommunity () {
        this.hasUnknownError = false
        this.hasError = false

        const communityName = this.attributes.ggdename

        this.$store.dispatch('property/GET_IS_VALID_COMMUNITY', communityName).then(res => {
          const { data, errors } = res

          if (errors || !data.gemeinden.length) {
            return
          }

          const { gemeinden } = data
          const { id } = gemeinden[0]
          this.tempGemeindeId = id
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    },
    computed: {
      noSearchResults () {
        return this.inputLength > 4 && !Object.keys(this.attributes).length
      },
      hasFoundResult () {
        return !!Object.keys(this.attributes).length
      },
      ...mapState({
        isValidCommunity: state => state.property.propertyAdd.isValidCommunity
      })
    },
    components: {
      Autocomplete
    }
  }
</script>

<style lang="scss" scoped>
  .link{
    text-decoration: underline;
    cursor: pointer;

    &:hover{
      text-decoration: underline;
    }
  }
  .type-ahead::v-deep{
    .autocomplete{
      border: none;

      input{
        background: $white;
        border: 1px solid $black-20;
        border-radius: 0.25rem;
        height: calc(1.5em + 1.2rem + 2px);
        padding: 0.6rem 0.75rem;
        font-size: inherit;
      }
    }
  }
</style>
